import type { ReactNode } from 'react';

import { ErrorState } from '@/ui/ErrorState';
import { CardSkeleton, TableSkeleton } from '@/ui/base/table-skeleton';

import { type CenarioDeTela } from './cenarioDeTela';

/**
 * Parte da mesma exceção deliberada de `cenarioDeTela.ts` — ver o comentário
 * lá. Mostra o mesmo esqueleto/erro que `EstadoDaTela` (padrão real, em
 * `modulos/admin/integracoes/EstadoDaTela.tsx`) mostraria, só que a partir do
 * cenário simulado em vez de uma consulta de verdade.
 */
interface EstadoSimuladoProps {
  cenario: CenarioDeTela;
  descricao: string;
  colunasDoEsqueleto?: number;
  children: ReactNode;
}

export function EstadoSimulado({
  cenario,
  descricao,
  colunasDoEsqueleto,
  children,
}: EstadoSimuladoProps) {
  if (cenario === 'carregando') {
    return (
      <div role="status" aria-live="polite">
        {colunasDoEsqueleto === undefined ? (
          <CardSkeleton />
        ) : (
          <TableSkeleton columns={colunasDoEsqueleto} />
        )}
        <p className="sr-only">Carregando {descricao}.</p>
      </div>
    );
  }

  if (cenario === 'erro') {
    return (
      <ErrorState
        variant="load-failed"
        title={`Não foi possível carregar ${descricao}`}
        primaryAction={{ label: 'Tentar de novo', onClick: () => window.location.reload() }}
      />
    );
  }

  return <>{children}</>;
}
